<app-user-header class="d-lg-none"></app-user-header>





<div class="col-md-12 big-area ps-2 pe-2">

    <div class="wrapperi">
        <div class="col-12 d-inline-flex justify-content-between w-100 p-0 mt-50">
            <div class="col-12 col-lg-6 pe-2 formed-search align-items-center d-flex">
                <div class="d-flex w-100">
                    <div class="search-cont-icon d-flex justify-content-center align-items-center">
                        <img src="../../assets/icons/search_icon.svg" alt="">
                    </div>
                    <div class="w-100">
                        <input type="text" (keyup)="search($event)" id="search-form" class="no-style-input w-100"
                            placeholder="Hae sijainnilla, toimipisteellä, nimikkeellä...">

                    </div>
                </div>
            </div>
            <div class=" mb-2 col-12 col-lg-6  ms-lg-6 ps-2 pe-2">
                <div class=" formed-search align-items-center d-flex">
                    <div class="d-flex w-100">
                        <div class="search-cont-icon d-flex justify-content-center align-items-center">
                            <img src="../../assets/icons/select_icon.svg" alt="">
                        </div>

                        <select (change)="sortOpenings()" type="text" id="sorting" placeholder="Valitse työaika"
                            class="formed-select">
                            <option value="new_applications_first">Kiinnostuneet ensin</option>
                            <option value="expired_first">Päättyneet ensin</option>
                            <option value="newest_first">Uusimmat ensin</option>

                        </select>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-12 ps-2 pe-2 m-0 pt-4">
            <app-top-banner [backgroundClass]="type == 'standard' ? 'banner-gray-bg' : 'banner-darkgreen-bg'"
                [title]="type == 'standard' ? '' : 'Parempi olla kartalla'"
                [buttonText]="type == 'standard' ? 'Lisää työpaikka' : 'Lisää pikahaku'"
                [imgSrc]="'../../assets/images/rekruu_jobs.jpg'"
                [btnLink]="'/'+businessID+'/openings/add-opening/' + type"
                [subtitle]="type == 'standard' ? 'Lisäämäsi ilmoitukset kohdennetaan oikealle ammattiryhmälle. Työnhakijat voivat ilmaista kiinnostuksensa avointa työpaikkaa kohtaan yhdellä klikkauksella.' : 'Formed-sovelluksen keikkakartalta tavoitat kaikki keikkatöistä ja sijaisuuksista kiinnostuneet hakijat.'"></app-top-banner>
        </div>



        <ng-template #no_op_search>
            <div class="col-12 row mb-4 ms-1">
                <p class="semiboldtextblue24 text-left mt-4">Ei lisättyjä työpaikkailmoituksia</p>


            </div>
        </ng-template>




        <div class="mt-2"></div>


        <div class="col-12 ps-0 pe-0 ps-lg-2 pe-lg-2 row m-0" *ngIf="openings && openings.length > 0; else no_openings">
            <div class="col-12 col-md-12  input-cover ">

                <div class="row between-margin">
                    <div class=" col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 h-100 ps-1 pe-2 row-margin"
                        *ngFor="let opening of openings">
                        <div class="card h-lg-100 formed-shadow hov-trans"
                            [ngClass]="opening['in_campaign'] == true? 'boosted-border' : opening['new_application'] && opening['in_campaign'] != true ? 'unopened-border' : ''"
                            routerLink="/{{businessID}}/openings/single-opening/{{opening._id}}">
                            <div class="" *ngIf="opening['new_application'] && opening['in_campaign'] != true ">
                                <div class="formed-new-badge">
                                    <p class="mb-0 normaltextwhite16">Avaamaton</p>
                                </div>
                            </div>
                            <div class="" *ngIf="opening['in_campaign']">
                                <div class="formed-boosted-badge">
                                    <p class="mb-0 normaltextwhite16">Boosted</p>
                                </div>
                            </div>
                            <div class="" *ngIf="opening['expired']">
                                <div class="formed-expired-badge">
                                    <p class="mb-0 normaltextwhite16">Hakuaika päättynyt</p>
                                </div>
                            </div>
                            <div class="card-body p-0">
                                <div class="header-wrap d-flex align-items-center justify-content-between p-2">
                                    <div class="">
                                        <p class="semiboldtextblue80016 mb-0 ms-3">{{opening.company_name}}</p>

                                    </div>
                                    <div class="me-3">
                                        <div class="" *ngIf="logo_url; else no_logo_added">
                                            <img src="{{logo_url}}" class="logo-wrap" alt="">

                                        </div>
                                        <ng-template #no_logo_added>
                                            <img src="../../assets/icons/company_icon_blue.svg" class="rounded-circle"
                                                width="40" height="40" alt="">
                                        </ng-template>

                                    </div>
                                </div>
                                <div class="title-cont p-2 mt-20 mb-2 ms-3">
                                    <div *ngIf="opening.application_version == 2" class="">
                                        <p class="semiboldtextblue80016 mb-0">{{opening.title}}</p>
                                    </div>
                                    <div class="" *ngIf="opening.application_version != 2">
                                        <p class="semiboldtextblue80016 mb-0">{{opening.mdType.grouping_name_fi}}</p>
                                        <div class="" *ngIf="opening.mdType.grouping_name_fi != opening.mdType.name_fi">
                                            <p class="normaltextblue16 mb-0">{{opening.mdType.name_fi}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-2 int-cont">
                                    <div class="">
                                        <div class="gray-box">
                                            <div class="width-20 text-center">
                                                <img width="17" src="../../assets/icons/star_dark_blue.svg">
                                            </div>
                                            <p class="normaltextblue80016 mb-0 ms-2 sm-m">Kiinnostuneet</p>
                                            <p class="semiboldtextblue80016 mb-0 ms-1 sm-m">
                                                {{opening.applicants_number}}</p>

                                        </div>
                                    </div>
                                </div>
                                <div class="oth-detail-container d-flex ps-2 pe-2 pb-4">
                                    <div class="">
                                        <div class="gray-box">
                                            <div class="width-20 text-center">
                                                <img width="16" src="../../assets/icons/location_dark_blue.svg">
                                            </div>
                                            <p class="normaltextblue80016 mb-0 ms-2 sm-m">{{opening.location.city}}</p>
                                        </div>
                                    </div>
                                    <div class="">
                                        <div class="gray-box">
                                            <div class="width-20 text-center">
                                                <img width="17" src="../../assets/icons/calendar_dark_blue.svg">
                                            </div>
                                            <p class="normaltextblue80016 mb-0 ms-2 sm-m"><span
                                                    *ngIf="opening.application_ends">Hakuaika päättyy:
                                                    {{opening.application_ends | formateDate}}</span> </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <ng-template #no_openings>
            <div class="col-12 row pb-4 mb-4" *ngIf="!isLoading">
                <div class="col-2">

                </div>
                <div class="col-12 col-lg-8">
                    <div class="bg-f-w p-4">
                        <div class="justify-content-center d-flex">
                            <img src="../../assets/images/no_search_found.png" height="270" alt="">

                        </div>
                        <div class="p-4">
                            <p class="semiboldtextblue24 text-center mt-4">
                                <span *ngIf="allOpenings.length == 0">Ei lisättyjä työpaikkailmoituksia</span>
                                <span *ngIf="allOpenings.length > 0">Ei hakutuloksia</span>
                            </p>
                            <p class="normaltextblue16 text-center">
                                <span *ngIf="allOpenings.length == 0">Lisää ensimmäinen työpaikkailmoituksesi alla
                                    olevasta painikkeesta</span>
                                <span *ngIf="allOpenings.length > 0">Ei hakutuloksia, kokeile toista hakua</span>
                            <div class="text-center justify-content-center d-flex">
                                <button class="btn btn-formed-main-blue mt-4"
                                    [routerLink]="'/'+businessID+'/openings/add-opening/' + type">Lisää
                                    työpaikka</button>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-2">

                </div>
            </div>
        </ng-template>
    </div>
</div>